import React, { useMemo } from 'react';
import { MY_TEAM_INDEX } from './liveAssistState';
import { OBJECTS, tallyTeamObjects } from './routeObjects';

// 지도 레이어 "팀별 오브젝트": 팀별로, 각 팀원이 가장 많이 쓰는 루트의 후반 교체 아이템(전설/신화)이 쓰는
// 오브젝트(운석/생명의 나무/미스릴/포스 코어/혈액팩) 개수를 표로 보여준다. 세는 규칙은 routeObjects.countObjects 참고. 인라인 스타일만 쓴다(PiP는 별도 창이라 CSS가 없음).

const MUTED = '#9aa0a6';
const MINE = '#52c41a'; // 우리 팀 표시색(PipTeamsView와 같음)

const teamLabel = (teamIndex) => (teamIndex === MY_TEAM_INDEX ? '우리 팀' : `${teamIndex + 1}팀`);

// 팀 안에서 그 오브젝트를 쓰는 팀원과 아이템 이름(마우스 올림 설명)
const memberDetail = (team, code) => team.members
  .filter((m) => m.objectCounts && m.objectCounts.items[code])
  .map((m) => `${m.characterName}: ${m.objectCounts.items[code].join(', ')}`)
  .join(' / ');

const cellStyle = (value, mine) => ({
  textAlign: 'center', padding: '4px 2px', fontWeight: value ? 800 : 400, color: value ? '#fff' : MUTED,
  fontSize: value ? 14 : 12, background: mine ? 'rgba(82,196,26,0.10)' : 'transparent',
});

function CountCell({ team, code, value, mine, title }) {
  return (
    <td style={cellStyle(value, mine)} title={title || undefined} data-team={team} data-code={code}>
      {value || '-'}
    </td>
  );
}

export default function PipObjectsView({ entries }) {
  const { teams, total } = useMemo(() => tallyTeamObjects(entries), [entries]);
  const sorted = useMemo(() => [...teams].sort((a, b) => a.teamIndex - b.teamIndex), [teams]);

  return (
    <div>
      <div style={{ color: MUTED, marginBottom: 6, lineHeight: '16px' }}>
        각 팀원이 가장 많이 쓰는 루트의 후반 교체 아이템이 쓰는 오브젝트 수 · 첫 번째 후반 교체 묶음(기본 빌드)만 셈
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
        <thead>
          <tr>
            <th style={{ width: 62 }} />
            {OBJECTS.map((o) => (
              <th key={o.key} style={{ padding: '2px 0', fontWeight: 400, fontSize: 10, color: MUTED }}>
                <img
                  src={`/img/item/${o.code}.png`}
                  alt={o.name}
                  style={{ width: 28, height: 28, display: 'block', margin: '0 auto 2px', objectFit: 'contain' }}
                  onError={(e) => { e.target.style.visibility = 'hidden'; }}
                />
                {o.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sorted.map((team) => {
            const mine = team.teamIndex === MY_TEAM_INDEX;
            return (
              <tr key={team.teamIndex} style={{ borderTop: '1px solid #3a3a4d' }}>
                <td style={{ padding: '4px 2px', background: mine ? 'rgba(82,196,26,0.10)' : 'transparent' }}>
                  <div style={{ fontWeight: 700, color: mine ? MINE : '#fff' }}>{teamLabel(team.teamIndex)}</div>
                  {team.pending > 0 && <div style={{ fontSize: 10, color: MUTED }}>조회 중 {team.pending}명</div>}
                  {team.unavailable > 0 && <div style={{ fontSize: 10, color: MUTED }}>알 수 없음 {team.unavailable}명</div>}
                </td>
                {OBJECTS.map((o) => (
                  <CountCell key={o.key} team={team.teamIndex} code={o.code} value={team.byCode[o.code] || 0} mine={mine} title={memberDetail(team, o.code)} />
                ))}
              </tr>
            );
          })}
          <tr style={{ borderTop: '2px solid #4a4a5d' }}>
            <td style={{ padding: '4px 2px', fontWeight: 700 }}>전체</td>
            {OBJECTS.map((o) => (
              <CountCell key={o.key} team="total" code={o.code} value={total.byCode[o.code] || 0} mine={false} />
            ))}
          </tr>
        </tbody>
      </table>
      {!sorted.length && <div style={{ color: MUTED, marginTop: 6 }}>루트를 조회하는 중이에요…</div>}
    </div>
  );
}
